<div>

    <div class="eagletext">The Eagle Society was created as a way to recognize
        and reward our most loyal guests. Our members receive special benefits, unique offers and enhanced personalized
        service to enrich their cruising experience. If you are not already a member, you are now eligible to enroll.
        Membership is always free.</div>
    <div class="EagleTitle">Membership Benefits</div>
    <div class="eagletextbullets">
        <ul class="bullet-list">
            <li>Members-only exclusive cruises</li>
            <li>Advance reservations to be the first on new ships and itineraries</li>
            <li>Members’ quarterly newsletter</li>
            <li>Eagle Society Referral Bonus – refer friends and family and you will both save $500 on your next booking
            </li>
            <li>An invitation to have family and friends visit you aboard during port calls (advance notice required,
                subject to availability)</li>
            <li>Complimentary Premium Shore Excursions after 3 cruises</li>
            <li>Complimentary 11<sup>th</sup> cruise</li>
        </ul>

    </div>
    <div class="esbutton">

        <div class="buttonarea" *ngFor="let guest of BookingGuestsInfo; let i=index;">
            <div class="row">

                <div class="col-2 benefitpoints" *ngIf="guest.loyaltylevel == 'ES' || EagleSocietyInfo == 'Completed'">
                    Member</div>
                <div class="col-3 benefitstars" *ngIf="guest.loyaltylevel == 'ES' || EagleSocietyInfo == 'Completed'">
                    {{guest.benefitpoints}}&nbsp;<i class="fa-sharp fa-solid fa-star"></i></div>

                <div class="col-4" *ngIf="guest.loyaltylevel != 'ES'"><button
                        class="signupbutton btn btn-outline-secondary" (click)="UpdateEagleSociety(guest);">Enroll
                        Now</button></div>
                <div class="col-7 guestname">{{guest.folFullNameSal}}</div>
                <!-- <span class="guestname">{{guest.folFullNameSal}}</span><span><button *ngIf="guest.loyaltylevel != 'ES'"
                        class="signupbutton btn btn-outline-secondary" (click)="UpdateEagleSociety(guest);">Enroll
                        Now</button></span><span class="benefitstars"
                    *ngIf="guest.loyaltylevel == 'ES' || EagleSocietyInfo == 'Completed'"><i
                        class="fa-sharp fa-solid fa-star"></i> {{guest.benefitpoints}} </span> -->
            </div>
        </div>
    </div>
</div>